import React from "react";
import star from '../assets/ico-star.png';

export default class DropdownItem extends React.Component {

    render() {

        const name = this.props.name;
        const is_default = !!this.props.is_default;

        return (
            <div className="amt-dropdown-item" onClick={this.props.onClick}>
                {name}
                {is_default ? <img className="amt-dropdown-item-default" src={star}/> : ''}
            </div>
        );
    }
}
